import { render, staticRenderFns } from "./RevenueData.vue?vue&type=template&id=c002cf74&scoped=true"
import script from "./RevenueData.vue?vue&type=script&lang=js"
export * from "./RevenueData.vue?vue&type=script&lang=js"
import style0 from "./RevenueData.vue?vue&type=style&index=0&id=c002cf74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c002cf74",
  null
  
)

export default component.exports